import { HOST_TOOL_NAMES } from "../../turns/turn-constants";
import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";

export const videoToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  [HOST_TOOL_NAMES.VIDEO_LIST, () => labelOnly("Listed the videos")],
  [HOST_TOOL_NAMES.VIDEO_CREATE, () => labelOnly("Created a video")],
  [HOST_TOOL_NAMES.VIDEO_READ, () => labelOnly("Read the video")],
  [
    HOST_TOOL_NAMES.VIDEO_SOURCE_RESTORE,
    () => labelOnly("Restored the video source"),
  ],
  [HOST_TOOL_NAMES.VIDEO_PUBLISH, () => labelOnly("Published a video version")],
  [HOST_TOOL_NAMES.GENERATE_VOICE, () => labelOnly("Generated narration")],
  [HOST_TOOL_NAMES.GENERATE_MUSIC, () => labelOnly("Generated music")],
  [
    HOST_TOOL_NAMES.GENERATE_SOUND_EFFECT,
    () => labelOnly("Generated a sound effect"),
  ],
  [HOST_TOOL_NAMES.LIST_VOICES, () => labelOnly("Listed the voices")],
  [HOST_TOOL_NAMES.VIDEO_SET_VOICES, () => labelOnly("Set the voices")],
];
